import { HostBridgeEvent } from "@hyland/minotaur";

export type HostBridgeEventCallback = (responseObject:HostBridgeEvent<any>) => void;

export enum HostBridgeEvents {
    authStateReceived = 'auth_state_received',
    logoutCompleted = 'logout_completed'
}

export interface AuthStateReceivedPayload {
	accessToken:string
}


// WEBPACK FOOTER //
// ./src/phoenix/domain/host-bridge.ts